import { Injectable } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import * as _ from 'lodash';
import { ActualiteModel } from '../../models/ActualiteModel';
import { ActualiteViewComponent } from './actualite-view/actualite-view.component';
import { ActualiteForListModel } from '../../models/ActualiteForListModel';

@Injectable({
  providedIn: 'root',
})
export class ActualiteService {
  constructor(private dialogService: DialogService) {}

  viewActu(actualite: ActualiteModel) {
    this.dialogService.open(ActualiteViewComponent, {
      data: {
        actualite: actualite,
        editMode: false,
      },
      header: actualite.Libelle,
      closeOnEscape: false,
      dismissableMask: false,
      width: '80%',
    });
  }

  ActualiteModel2ActualiteForListModel(actualiteModel: ActualiteModel): ActualiteForListModel {
    return {
      Id: actualiteModel.Id,
      Libelle: actualiteModel.Libelle,
      Creation: actualiteModel.Creation,
      EtablissementId: actualiteModel.EtablissementId,
      Etablissement: { ...actualiteModel.Etablissement },
      DebutAffichage: actualiteModel.DebutAffichage,
      FinAffichage: actualiteModel.FinAffichage,
      LogoFilename: actualiteModel.LogoFilename,
      LogoUrl: actualiteModel.LogoUrl,
    };
  }
}
